import { render } from "./Buyback.vue?vue&type=template&id=99c08c2e&scoped=true&ts=true&lang=pug"
import script from "./Buyback.vue?vue&type=script&lang=ts"
export * from "./Buyback.vue?vue&type=script&lang=ts"

import "./Buyback.vue?vue&type=style&index=0&id=99c08c2e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c08c2e"]])

export default __exports__